export default __webpack_public_path__ + "static/gitex-fff8e93d47ab42024c1c8acbb8400cbd.mp4";